import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

import { onImportError } from './services/updateChecker.ts'

const AcceptUserInvitation = () => import('./components/AcceptUserInvitation.vue').catch(onImportError)
const Auth = () => import('./components/auth/Auth.vue').catch(onImportError)
const ChooseOrganization = () => import('./components/auth/ChooseOrganization.vue').catch(onImportError)
const IdentityVerification = () => import('./components/IdentityVerification.vue').catch(onImportError)
const ExternalOnboardingForm = () => import('./components/ExternalOnboardingForm.vue').catch(onImportError)
const ExternalOnboardingForms = () => import('./components/ExternalOnboardingForms.vue').catch(onImportError)
const InactiveOrganization = () => import('./components/InactiveOrganization.vue').catch(onImportError)
const Login = () => import('./components/auth/Login.vue').catch(onImportError)
const OnboardingFormExternalAuthentication = () => import('./components/OnboardingFormExternalAuthentication.vue').catch(onImportError)
const PlanManagementComplete = () => import('./components/PlanManagementComplete.vue').catch(onImportError)
const Reset = () => import('./components/auth/Reset.vue').catch(onImportError)
const ResetEmail = () => import('./components/auth/ResetEmail.vue').catch(onImportError)
const Response = () => import('./components/auth/Response.vue').catch(onImportError)
const SettingsAccountGeneral = () => import('./components/Settings/SettingsAccountGeneral.vue').catch(onImportError)
const SettingsAccountNotifications = () => import('./components/Settings/SettingsAccountNotifications.vue').catch(onImportError)
const SettingsOnboardingExternalConfiguration = () => import('./components/Settings/SettingsOnboardingExternalConfiguration.vue').catch(onImportError)
const SettingsOnboardingPolicies = () => import('./components/Settings/SettingsOnboardingPolicies.vue').catch(onImportError)
const SettingsOnboardingRiskConfiguration = () => import('./components/Settings/SettingsOnboardingRiskConfiguration.vue').catch(onImportError)
const SettingsOrganizationAccountDetails = () => import('./components/Settings/SettingsOrganizationAccountDetails.vue').catch(onImportError)
const SettingsOrganizationIntegrations = () => import('./components/Settings/SettingsOrganizationIntegrations.vue').catch(onImportError)
const SettingsOrganizationRiskClassification = () => import('./components/Settings/SettingsOrganizationRiskClassification.vue').catch(onImportError)
const SettingsOrganizationSecurity = () => import('./components/Settings/SettingsOrganizationSecurity.vue').catch(onImportError)
const SettingsOrganizationSubscription = () => import('./components/Settings/SettingsOrganizationSubscription.vue').catch(onImportError)
const SettingsOrganizationUsersAndGroups = () => import('./components/Settings/SettingsOrganizationUsersAndGroups.vue').catch(onImportError)
const SettingsScreeningDataDirectory = () => import('./components/Settings/SettingsScreeningDataDirectory.vue').catch(onImportError)
const DataDirectoryEntries = () => import('./components/DataDirectoryEntries.vue').catch(onImportError)
const SettingsScreeningPolicies = () => import('./components/Settings/SettingsScreeningPolicies.vue').catch(onImportError)
const SettingsScreeningRiskClassification = () => import('./components/Settings/SettingsScreeningRiskClassification.vue').catch(onImportError)
const SettingsTransactionMonitoringExemptions = () => import('./components/Settings/SettingsTransactionMonitoringExemptions.vue').catch(onImportError)
const SettingsTransactionMonitoringScenarios = () => import('./components/Settings/SettingsTransactionMonitoringScenarios.vue').catch(onImportError)
const SettingsTransactionMonitoringImporting = () => import('./components/Settings/SettingsTransactionMonitoringImporting.vue').catch(onImportError)
const SettingsTransactionMonitoringPolicies = () => import('./components/Settings/SettingsTransactionMonitoringPolicies.vue').catch(onImportError)
const SettingsTransactionMonitoringRiskClassification = () => import('./components/Settings/SettingsTransactionMonitoringRiskClassification.vue').catch(onImportError)
const StatisticsCases = () => import('./components/StatisticsCases.vue').catch(onImportError)
const StatisticsMonitoring = () => import('./components/StatisticsMonitoring.vue').catch(onImportError)
const StatisticsReports = () => import('./components/StatisticsReports.vue').catch(onImportError)
const StatisticsActivity = () => import('./components/StatisticsActivity.vue').catch(onImportError)
const StatisticsResolvement = () => import('./components/StatisticsResolvement.vue').catch(onImportError)
const ViewAlerts = () => import('./components/Alerts/ViewAlerts.vue').catch(onImportError)
const ViewApp = () => import('./components/ViewApp.vue').catch(onImportError)
const ViewBlue = () => import('./components/ViewBlue.vue').catch(onImportError)
const ViewCase = () => import('./components/CaseDashboard/ViewCase.vue').catch(onImportError)
const ViewCases = () => import('./components/ViewCases.vue').catch(onImportError)
const ViewClient = () => import('./components/Clients/ViewClient.vue').catch(onImportError)
const ViewClients = () => import('./components/Clients/ViewClients.vue').catch(onImportError)
const ViewExemptionList = () => import('./components/ViewExemptionList.vue').catch(onImportError)
const ViewHome = () => import('./components/ViewHome.vue').catch(onImportError)
const ViewOnboardingExternal = () => import('./components/ViewOnboardingExternal.vue').catch(onImportError)
const ViewOnboardingForm = () => import('./components/ViewOnboardingForm.vue').catch(onImportError)
const ViewOnboardingFormTemplate = () => import('./components/ViewOnboardingFormTemplate.vue').catch(onImportError)
const ViewOnboardingFormTemplates = () => import('./components/ViewOnboardingFormTemplates.vue').catch(onImportError)
const ViewOneTimeCase = () => import('./components/ViewOneTimeCase.vue').catch(onImportError)
const ViewRateEmail = () => import('./components/ViewRateEmail.vue').catch(onImportError)
const ViewSettings = () => import('./components/ViewSettings.vue').catch(onImportError)
const ViewSignup = () => import('./components/ViewSignup.vue').catch(onImportError)
const ViewStatistics = () => import('./components/ViewStatistics.vue').catch(onImportError)
const ViewTransactionMonitoringAlertTemplate = () => import('./components/ViewTransactionMonitoringAlertTemplate.vue').catch(onImportError)
const ViewTransactionAnalysisTransactions = () => import('./components/Transactions/ViewTransactionAnalysisTransactions.vue').catch(onImportError)

// Spectrum routes.
const SpectrumCommands = () => import('./components/Spectrum/SpectrumCommands.vue').catch(onImportError)
const SpectrumEngagementOffboardings = () => import('./components/Spectrum/SpectrumEngagementOffboardings.vue').catch(onImportError)
const SpectrumEngagementOrganizations = () => import('./components/Spectrum/SpectrumEngagementOrganizations.vue').catch(onImportError)
const SpectrumLogs = () => import('./components/Spectrum/SpectrumLogs.vue').catch(onImportError)
const SpectrumOrganizationAccountDetails = () => import('./components/Spectrum/SpectrumOrganizationAccountDetails.vue').catch(onImportError)
const SpectrumOrganizationEngagement = () => import('./components/Spectrum/SpectrumOrganizationEngagement.vue').catch(onImportError)
const SpectrumOrganizationSubscription = () => import('./components/Spectrum/SpectrumOrganizationSubscription.vue').catch(onImportError)
const SpectrumOrganizationTierPolicy = () => import('./components/Spectrum/SpectrumOrganizationTierPolicy.vue').catch(onImportError)
const SpectrumOrganizationUsage = () => import('./components/Spectrum/SpectrumOrganizationUsage.vue').catch(onImportError)
const SpectrumPermissions = () => import('./components/Spectrum/SpectrumPermissions.vue').catch(onImportError)
const SpectrumCustomText = () => import('./components/Spectrum/SpectrumCustomText.vue').catch(onImportError)
const SpectrumRoles = () => import('./components/Spectrum/SpectrumRoles.vue').catch(onImportError)
const SpectrumUsageEmail = () => import('./components/Spectrum/SpectrumUsageEmail.vue').catch(onImportError)
const SpectrumUsageFeatures = () => import('./components/Spectrum/SpectrumUsageFeatures.vue').catch(onImportError)
const SpectrumUsers = () => import('./components/Spectrum/SpectrumUsers.vue').catch(onImportError)
const ViewSpectrumHome = () => import('./components/ViewSpectrumHome.vue').catch(onImportError)
const ViewSpectrumOrganization = () => import('./components/ViewSpectrumOrganization.vue').catch(onImportError)
const ViewSpectrumOrganizations = () => import('./components/ViewSpectrumOrganizations.vue').catch(onImportError)
const ViewSpectrumUsers = () => import('./components/ViewSpectrumUsers.vue').catch(onImportError)

export const router = createRouter({
  history: window.location.pathname === '/' ? createWebHashHistory() : createWebHistory(),
  routes: [
    {
      // The Auth component renders a view which is used on authentication pages like login or reset password.
      // These are only accessible by guest users.
      path: '/login',
      component: Auth,
      children: [
        { path: '/login', component: Login, meta: { title: 'Sign in', guest: true } },
        { path: '/password/reset', component: ResetEmail, meta: { title: 'Reset your password', guest: true } },
        { path: '/password/reset/:token', component: Reset, meta: { title: 'Reset your password', guest: true } },
        { path: '/response', component: Response, meta: { title: 'Response', guest: true } },
      ],
    },

    { path: '/sanction-screening', redirect: () => ({ path: '/signup' }), meta: { guest: true } },

    {
      path: '/signup',
      component: ViewSignup,
      children: [{ path: '/signup', component: ViewSignup, meta: { title: 'Signup for Pascal', guest: true } }],
    },

    {
      // ViewBlue shows the content in a specific layout / style. Any component can be added here.
      path: '/view-blue',
      component: ViewBlue,
      children: [
        { path: '/signup-complete', component: PlanManagementComplete, meta: { title: 'Signup for Pascal', guest: true } },
        { path: '/inactive-organisation', component: InactiveOrganization, meta: { title: 'Inactive organisation' } },
        { path: '/choose-organisation', component: ChooseOrganization, meta: { title: 'Choose organisation', guest: true, allowSignedIn: true } },
        {
          path: '/user-invitations/:id',
          component: AcceptUserInvitation,
          meta: { title: 'User invitation', guest: true, allowSignedIn: true },
          props: (route) => ({
            invitationId: Number(route.params.id),
            invitationToken: route.query.invitation_token,
          }),
        },
        {
          path: '/onboarding-form-external-authentication',
          component: OnboardingFormExternalAuthentication,
          meta: { title: 'Authentication', guest: true, allowSignedIn: true },
          props: (route) => ({ email: route.query.email ?? '' }),
        },
      ],
    },

    {
      path: '/external-view',
      component: ViewOnboardingExternal,
      children: [
        {
          path: '/external-onboarding-forms',
          component: ExternalOnboardingForms,
          meta: { title: 'Onboarding' },
        },
        {
          path: '/external-onboarding-forms/:id',
          component: ExternalOnboardingForm,
          meta: { keyByPath: true, title: 'Form' },
          props: (route) => ({ id: Number(route.params.id) }),
        },
        {
          path: '/identity-verifications/:uuid',
          component: IdentityVerification,
          meta: { title: 'Identity verification', guest: true, allowSignedIn: true },
          props: (route) => ({ uuid: route.params.uuid }),
        },
      ],
    },

    {
      path: '/rate-email',
      component: ViewRateEmail,
      meta: { title: 'Email feedback' },
      props: (route) => ({
        emailType: route.query.email_type,
        liked: route.query.liked === '1',
      }),
    },

    { path: '/one-time-case', component: ViewOneTimeCase },

    {
      // ViewApp contains routes that are accessed by a signed in user in a valid organization.
      path: '/',
      meta: { organizationRequired: true },
      name: 'root',
      component: ViewApp,
      children: [
        { path: '/', component: ViewHome, meta: { title: 'Home' } },
        { path: '/clients', component: ViewClients, name: 'clients', meta: { keyByPath: true, title: 'Clients' } },
        { path: '/clients/:id', component: ViewClient, name: 'clients.id' },
        {
          path: '/onboarding-forms/:id',
          component: ViewOnboardingForm,
          meta: { keyByPath: true, title: 'Form', module: 'onboarding' },
          props: (route) => ({ id: Number(route.params.id) }),
        },
        { path: '/alerts', component: ViewAlerts, name: 'alerts', meta: { title: 'Alerts', module: 'transaction_monitoring' } },
        {
          path: '/transaction-monitoring/alert-templates/:id',
          component: ViewTransactionMonitoringAlertTemplate,
          name: 'transaction-monitoring.alert-templates.id',
          meta: { title: 'Alerts', module: 'transaction_monitoring' },
          props: (route) => ({ id: route.params.id === 'new' ? undefined : Number(route.params.id) }),
        },
        { path: '/cases', component: ViewCases, meta: { keyByPath: true, title: 'Cases' } },
        {
          path: '/cases/:uuid',
          component: ViewCase,
          props: (route) => ({ dialogResolveVisible: route.query.resolve ? true : false }),
        },
        {
          path: '/:type(.*)*-check/:uuid',
          redirect: (to) => ({ path: `/cases/${to.params.uuid}` }),
        },
        {
          path: '/statistics',
          component: ViewStatistics,
          children: [
            { path: '', redirect: (to) => `${to.path}/resolvement` },
            { path: 'resolvement', component: StatisticsResolvement, meta: { title: 'Resolvement' } },
            { path: 'activity', component: StatisticsActivity, meta: { title: 'Activity', permission: 'analytics.view' } },
            { path: 'cases', component: StatisticsCases, meta: { title: 'Cases' } },
            { path: 'analysis', component: ViewTransactionAnalysisTransactions, meta: { title: 'Transaction Analysis', module: 'transaction_monitoring' } },

            {
              path: 'reports',
              component: StatisticsReports,
              meta: { title: 'Reports' },
            },
            { path: 'monitoring', component: StatisticsMonitoring, meta: { title: 'Monitoring' } },
            { path: 'monitoring/:id', component: StatisticsMonitoring, meta: { title: 'Monitoring' } },
          ],
        },
        {
          path: '/settings',
          children: [
            {
              path: '',
              component: ViewSettings,
              children: [
                { path: '', redirect: (to) => `${to.path}/general` },
                { path: 'general', component: SettingsAccountGeneral, meta: { title: 'General' } },
                { path: 'notifications', component: SettingsAccountNotifications, meta: { title: 'Notifications' } },
                { path: 'onboarding/forms', name: 'form-templates', component: ViewOnboardingFormTemplates, meta: { title: 'Forms', module: 'onboarding' } },
              ],
            },
            {
              path: 'onboarding/forms/:id',
              name: 'form-templates.id',
              component: ViewOnboardingFormTemplate,
              meta: { title: 'Form template', module: 'onboarding', permission: 'onboardingFormTemplates.update' },
              props: (route) => ({ id: Number(route.params.id) }),
            },
          ],
        },
        {
          path: '/organizations/:organizationId',
          children: [
            {
              path: '',
              component: ViewSettings,
              meta: { title: 'Organisation' },
              children: [
                // General.
                { path: '', redirect: (to) => `${to.path}/account-details` },
                { path: 'subscription', component: SettingsOrganizationSubscription, meta: { title: 'Subscription', permission: 'subscriptions.manage' } },
                { path: 'account-details', component: SettingsOrganizationAccountDetails, meta: { title: 'Account details' } },
                { path: 'security', component: SettingsOrganizationSecurity, meta: { title: 'Security' } },
                { path: 'users-and-groups', component: SettingsOrganizationUsersAndGroups, meta: { title: 'Users & groups' } },
                { path: 'integrations', component: SettingsOrganizationIntegrations, meta: { title: 'Integrations', permission: 'organizationIntegrations.view' } },
                {
                  path: 'risk-classification',
                  component: SettingsOrganizationRiskClassification,
                  meta: { title: 'Risk classification', permission: 'organizationRiskConfigs.update' },
                },

                // Onboarding.
                { path: 'onboarding-policies', component: SettingsOnboardingPolicies, meta: { title: 'Policies', module: 'onboarding' } },
                {
                  path: 'onboarding-external-configuration',
                  component: SettingsOnboardingExternalConfiguration,
                  meta: { title: 'External configuration', module: 'onboarding' },
                },
                {
                  path: 'onboarding-risk-configuration',
                  component: SettingsOnboardingRiskConfiguration,
                  meta: { title: 'Risk configuration', module: 'onboarding' },
                },

                // Screening.
                { path: 'screening-policies', component: SettingsScreeningPolicies, meta: { title: 'Policies' } },
                {
                  path: 'screening-risk-classification',
                  component: SettingsScreeningRiskClassification,
                  meta: { title: 'Risk Classification', permission: 'organizationRiskConfigs.update' },
                },
                {
                  path: 'screening-data-directory',
                  component: SettingsScreeningDataDirectory,
                  meta: { permission: 'dataDirectory.update', service: 'dataDirectory', title: 'Data Directory' },
                },

                // TM.
                {
                  path: 'transaction-monitoring-policies',
                  component: SettingsTransactionMonitoringPolicies,
                  meta: { module: 'transaction_monitoring', title: 'Policies' },
                },
                {
                  path: 'transaction-monitoring-risk-classification',
                  component: SettingsTransactionMonitoringRiskClassification,
                  meta: { module: 'transaction_monitoring', title: 'Risk classification' },
                },
                { path: 'transaction-monitoring-exemptions', component: SettingsTransactionMonitoringExemptions, meta: { module: 'transaction_monitoring', title: 'Exemptions' } },
                { path: 'transaction-monitoring-scenarios', component: SettingsTransactionMonitoringScenarios, meta: { module: 'transaction_monitoring', title: 'Scenarios' } },
                {
                  path: 'transaction-monitoring-importing',
                  component: SettingsTransactionMonitoringImporting,
                  meta: { module: 'transaction_monitoring', title: 'Importing' },
                },
              ],
            },
            {
              path: 'transaction-monitoring-exemptions/:id',
              component: ViewExemptionList,
              meta: { module: 'transaction_monitoring', keyByPath: true, title: 'Exemption list' },
              props: (route) => ({ id: Number(route.params.id) }),
            },
            {
              path: 'screening-data-directory/:dataDirectoryId',
              component: DataDirectoryEntries,
              meta: { permission: 'dataDirectory.update', service: 'dataDirectory', title: 'Data Directory' },
            },
          ],
        },

        // Administration routes.
        {
          path: '/administration/home',
          component: ViewSpectrumHome,
          meta: { permission: 'administrations.view', title: 'Administration' },
          children: [
            {
              path: '',
              redirect: (to) => {
                const permissions = {
                  'administrations.engagement': `${to.path}/engagement-organizations`,
                  'administrations.usage': `${to.path}/usage-features`,
                  'administrations.authorization': `${to.path}/spectrum-authorization`,
                  'administrations.commands': `${to.path}/spectrum-commands`,
                  'administrations.logs': `${to.path}/spectrum-logs`,
                  'administrations.organizations.edit': `${to.path}/custom-text`,
                  'administrations.organizations.view': '/administration/organizations',
                  'administrations.users': '/administration/users',
                  'administrations.cases': '/administration/cases',
                  'administrations.clients': '/administration/clients',
                }

                for (const [permission, path] of Object.entries(permissions)) {
                  if (can(permission)) {
                    return path
                  }
                }

                // If you don't have any spectrum page permission, redirect to the home page.
                return '/'
              },
              name: 'administration',
            },
            {
              path: 'engagement-organizations',
              component: SpectrumEngagementOrganizations,
              meta: { permission: 'administrations.engagement', title: 'Organisations' },
            },
            { path: 'engagement-offboardings', component: SpectrumEngagementOffboardings, meta: { permission: 'administrations.engagement', title: 'Offboardings' } },
            { path: 'usage-features', component: SpectrumUsageFeatures, meta: { permission: 'administrations.usage', title: 'Features' } },
            { path: 'usage-email', component: SpectrumUsageEmail, meta: { permission: 'administrations.usage', title: 'Emails' } },
            { path: 'spectrum-users', component: SpectrumUsers, meta: { permission: 'administrations.authorization', title: 'Users' } },
            { path: 'spectrum-roles', component: SpectrumRoles, meta: { permission: 'administrations.authorization', title: 'Roles' } },
            { path: 'spectrum-permissions', component: SpectrumPermissions, meta: { permission: 'administrations.authorization', title: 'Permissions' } },
            { path: 'spectrum-commands', component: SpectrumCommands, meta: { permission: 'administrations.commands', title: 'Commands' } },
            { path: 'spectrum-logs', component: SpectrumLogs, meta: { permission: 'administrations.logs', title: 'Logs' } },
            { path: 'custom-text', component: SpectrumCustomText, meta: { permission: 'administrations.organizations.edit', title: 'Custom text' } },
          ],
        },
        {
          path: '/administration/organizations',
          component: ViewSpectrumOrganizations,
          meta: { permission: 'administrations.organizations.view', title: 'Organisations' },
        },
        {
          path: '/administration/organizations/:organizationId',
          component: ViewSpectrumOrganization,
          meta: { permission: 'administrations.organizations.view', title: 'Organisation' },
          children: [
            { path: '', redirect: (to) => `${to.path}/account-details`, name: 'organization' },
            { path: 'account-details', component: SpectrumOrganizationAccountDetails, meta: { title: 'Account details' } },
            { path: 'subscription', component: SpectrumOrganizationSubscription, meta: { title: 'Subscription' } },
            {
              path: 'engagement',
              component: SpectrumOrganizationEngagement,
              meta: { title: 'Engagement' },
              props: (route) => ({ organizationId: route.params.organizationId }),
            },
            { path: 'usage', component: SpectrumOrganizationUsage, meta: { title: 'Usage' }, props: (route) => ({ organizationId: route.params.organizationId }) },
            { path: 'tier-policy', component: SpectrumOrganizationTierPolicy, meta: { title: 'Tier policy' } },
          ],
        },
        {
          path: '/administration/clients',
          component: ViewClients,
          meta: { keyByPath: true, permission: 'administrations.clients', title: 'Clients' },
        },
        { path: '/administration/cases', component: ViewCases, meta: { keyByPath: true, permission: 'administrations.cases', title: 'Cases' } },
        {
          path: '/administration/cases/:uuid',
          component: ViewCase,
          props: (route) => ({ dialogResolveVisible: route.query.resolve ? true : false }),
          meta: { permission: 'administrations.cases' },
        },
        { path: '/administration/users', component: ViewSpectrumUsers, meta: { permission: 'administrations.users', title: 'Users' } },
      ],
    },

    // Redirect not found to home page.
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior() {
    // We define our own scrolling behaviour in `router-helpers.ts` `onAfterRouteChange`.
    return false
  },
})

window.$router = router
export const route = router.currentRoute
window.$route = route
